import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

export const EmptyState: React.FC<{
  title: string
}> = ({ title }) => {
  return (
    <Box alignItems="center" gap="s16" paddingTop="s16">
      <Icon.Large icon="document-folder-drawer-2" color="grey600" />
      <Box gap="s4" alignItems="center">
        <Text.Header2>{i18n.t('data_table.empty_state.data.title')}</Text.Header2>
        <Text.Normal color="grey800">{title}</Text.Normal>
      </Box>
    </Box>
  )
}
